import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { Button } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";

const CommonDialog = ({
  open,
  handleDialogCLose,
  handleSaveOperation,
  content,
  saveBtnText = "Save",
  cancelBtnText = "Cancel",
  showCancelBtn = true,
  showSaveBtn = true,
  headerText = "Dialog Header",
  isSaveBtnLoading = false,
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialogCLose}
        PaperProps={{
          sx: {
            minWidth: "50%", // Set your desired minimum width in pixels
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">{headerText}</Typography>
          <IconButton
            aria-label="close"
            onClick={handleDialogCLose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {showCancelBtn ? (
            <Button
              onClick={handleDialogCLose}
              style={{
                backgroundColor: "transparent",
                color: "rgba(34, 75, 153, 1)",
              }}
            >
              {cancelBtnText}
            </Button>
          ) : null}
          {showSaveBtn ? (
            <Button onClick={handleSaveOperation} disabled={isSaveBtnLoading}>
              {saveBtnText}
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CommonDialog;
